import { z } from 'zod';

export const thoughtLeadershipRowSchema = z.object({
  id: z.string().min(1),
  title: z.string().min(1),
  description: z.string(),
  iconName: z.string(),
  image: z.string().nullable(),
  link: z.string().nullable(),
  tag: z.string().nullable(),
  sortOrder: z.number().int(),
  visible: z.boolean(),
});

export const thoughtLeadershipInsertSchema = z.object({
  id: z.string().min(1).optional(),
  title: z.string().min(1),
  description: z.string(),
  iconName: z.string().optional(),
  image: z.string().nullable().optional(),
  link: z.string().nullable().optional(),
  tag: z.string().nullable().optional(),
  sortOrder: z.number().int().optional(),
  visible: z.boolean().optional(),
});

export const thoughtLeadershipUpdateSchema = thoughtLeadershipInsertSchema.partial();

export type ThoughtLeadershipRow = z.infer<typeof thoughtLeadershipRowSchema>;
export type ThoughtLeadershipInsert = z.input<typeof thoughtLeadershipInsertSchema>;
export type ThoughtLeadershipUpdate = z.input<typeof thoughtLeadershipUpdateSchema>;
